

$('.blog-posts__slider').each(function(key) {

    var sliderIdName = 'blogSlider' + key;
    var sliderNavIdName = 'blogSliderNav' + key;
  
    this.id = sliderIdName;
    $('.blog-block__buttons')[key].id = sliderNavIdName;
  
    var sliderId = '#' + sliderIdName;

    var prevButtonBlog = document.querySelectorAll('.blog-block__prev-button');
    var nextButtonBlog = document.querySelectorAll('.blog-block__next-button');

  
    $(sliderId).slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: prevButtonBlog[key],
        nextArrow: nextButtonBlog[key],
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    prevArrow: prevButtonBlog[key],
                    nextArrow: nextButtonBlog[key],
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    prevArrow: prevButtonBlog[key],
                    nextArrow: nextButtonBlog[key],
                },
            },
        ],
    });
});
